// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"TempHotelResults_iconSync__3Fh1C","fa-spin":"TempHotelResults_fa-spin__2Qqxk"};